export { default as Modal } from './Modal';
export * as Styled from './Modal.styles';
export * from './Modal.types';
